import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import escapeRegExp from "lodash/escapeRegExp";
import * as React from "react";
export var highlightWord = function(highlight, word) {
    if (!highlight.trim() || !word) {
        return [
            word
        ];
    }
    // Wrapping in try-catch block to prevent any fatal errors from bad input
    try {
        var regExp = new RegExp(escapeRegExp(highlight), "gi");
        var charPointer = 0;
        var pieces = [];
        var exec = regExp.exec(word);
        while(exec){
            var _exec_;
            var matchStart = exec.index;
            if (matchStart > charPointer) {
                pieces.push(word.substr(charPointer, matchStart - charPointer));
            }
            pieces.push(/*#__PURE__*/ _jsx("strong", {
                children: exec[0]
            }, matchStart));
            var _exec__length;
            charPointer = matchStart + ((_exec__length = (_exec_ = exec[0]) === null || _exec_ === void 0 ? void 0 : _exec_.length) !== null && _exec__length !== void 0 ? _exec__length : 0);
            exec = regExp.exec(word);
        }
        if (charPointer < word.length) {
            pieces.push(word.substr(charPointer, word.length));
        }
        return pieces;
    } catch (e) {
        return [];
    }
};
var highlightStringExceptWord = function(highlight, word) {
    if (!highlight.trim() || !word) {
        return [
            word
        ];
    }
    // Wrapping in try-catch block to prevent any fatal errors from bad input
    try {
        var regExp = new RegExp("\\b" + escapeRegExp(highlight).trim(), "gi");
        var charPointer = 0;
        var pieces = [];
        var exec = regExp.exec(word);
        while(exec){
            var _exec_;
            var matchStart = exec.index;
            if (matchStart > charPointer) {
                pieces.push(/*#__PURE__*/ _jsx("strong", {
                    children: word.substr(charPointer, matchStart - charPointer)
                }, matchStart));
            }
            pieces.push(exec[0]);
            var _exec__length;
            charPointer = matchStart + ((_exec__length = (_exec_ = exec[0]) === null || _exec_ === void 0 ? void 0 : _exec_.length) !== null && _exec__length !== void 0 ? _exec__length : 0);
            exec = regExp.exec(word);
        }
        if (charPointer < word.length) {
            pieces.push(/*#__PURE__*/ _jsx("strong", {
                children: word.substr(charPointer, word.length)
            }, charPointer));
        }
        return pieces;
    } catch (e) {
        return [];
    }
};
var StringHighlight = function(param) {
    var message = param.message, highlight = param.highlight, className = param.className, _param_reverseHighlight = param.reverseHighlight, reverseHighlight = _param_reverseHighlight === void 0 ? false : _param_reverseHighlight;
    var sections = message.split("/");
    var lastSection = sections.pop();
    if (!highlight || !lastSection) {
        return /*#__PURE__*/ _jsx("span", {
            className: className,
            children: message
        });
    }
    sections.push("");
    var prefix = sections.join("/");
    return /*#__PURE__*/ _jsxs("span", {
        className: className,
        children: [
            prefix,
            reverseHighlight ? highlightStringExceptWord(highlight, lastSection) : highlightWord(highlight, lastSection)
        ]
    });
};
export default StringHighlight;
